// src/pages/PesquisaJurisprudencia/components/CasoTab.js
import React from 'react';

const CasoTab = ({
  casos,
  casoSelecionado,
  loadingCasos,
  loadingPesquisaCaso,
  handleCasoChange,
  encontrarJurisprudenciaPorCaso,
  formatarData
}) => {
  return (
    <div className="pesquisa-caso-container">
      <div className="filtros-container">
        <div className="caso-selection-grid">

          {/* Seleção do Caso */}
          <div className="campo-grupo">
            <label>Selecionar Caso Jurídico:</label>
            <select
              className="caso-select"
              onChange={(e) => handleCasoChange(e.target.value)}
              disabled={loadingCasos}
              value={casoSelecionado?.id || ''}
            >
              <option value="">
                {loadingCasos ? 'Carregando casos...' : 'Selecione um caso'}
              </option>
              {casos.map(caso => (
                <option key={caso.id} value={caso.id}>
                  {caso.name || `Caso ${caso.id}`} - {formatarData(caso.created_at)}
                </option>
              ))}
            </select>
          </div>

          {/* Detalhes do Caso Selecionado */}
          {casoSelecionado && (
            <div className="campo-grupo caso-detalhes">
              <label>Detalhes do Caso:</label>
              <div className="caso-info-box">
                <div className="caso-info-header">
                  <h4>{casoSelecionado.name || `Caso ${casoSelecionado.id}`}</h4>
                  <span className="caso-data">{formatarData(casoSelecionado.created_at)}</span>
                </div>
                <div className="caso-content">
                  <div className="caso-field">
                    <label>Descrição:</label>
                    <textarea
                      className="caso-textarea"
                      value={casoSelecionado.description || 'Nenhuma descrição disponível'}
                      readOnly
                      rows={8}
                    />
                  </div>
                  {casoSelecionado.analise_caso && (
                    <div className="caso-field">
                      <label>Análise do Caso:</label>
                      <textarea
                        className="caso-textarea"
                        value={
                          typeof casoSelecionado.analise_caso === 'string'
                            ? casoSelecionado.analise_caso
                            : JSON.stringify(casoSelecionado.analise_caso, null, 2)
                        }
                        readOnly
                        rows={6}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        <button
          className="botao-pesquisar"
          onClick={encontrarJurisprudenciaPorCaso}
          disabled={loadingPesquisaCaso || !casoSelecionado}
        >
          {loadingPesquisaCaso
            ? 'Buscando jurisprudência relacionada...'
            : 'ENCONTRAR JURISPRUDÊNCIA'}
        </button>
      </div>

      {!casoSelecionado && !loadingCasos && casos.length > 0 && (
        <div className="aviso-caso">
          👆 Selecione um caso para encontrar jurisprudência relacionada
        </div>
      )}

      {loadingCasos && (
        <div className="loading">Carregando seus casos jurídicos...</div>
      )}

      {!loadingCasos && casos.length === 0 && (
        <div className="sem-casos">
          📋 Você ainda não possui casos cadastrados. Acesse "Gestão de Casos" para criar um novo caso.
        </div>
      )}
    </div>
  );
};

export default CasoTab;